/**
 * Icon-system constants — kept separate from Icon.tsx so that file only exports
 * components (satisfies react-refresh/only-export-components; keeps Fast Refresh working).
 */

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/** Fixed size steps (px). No in-between — pick a step; default md. */
export const ICON_SIZE_PX: Record<IconSize, number> = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};
